import '@aws-amplify/ui-react/styles.css';
import { Auth } from 'aws-amplify';
import { awsExports } from "../aws-exports";
import { getS3Object, getS3ObjectTags, parseJwt } from "./dao";
import { ExperimentFolder } from "./entities/ExperimentFolder";
import { Issue } from "./entities/Issue";


export let jwt = null;
export let userCognitoGroup = null;
export let user = null;
export let pathToFolder = null;

export const getAuthData = async () => {
  let jwtRaw = (await Auth.currentSession()).getAccessToken().getJwtToken();
  jwt = parseJwt(jwtRaw);
  userCognitoGroup = jwt['cognito:groups'][0];
  user = jwt['username'];
  pathToFolder = `${awsExports.ACCESS_PREFIX}${userCognitoGroup}`

  return pathToFolder;
}

export const getExperiments = async (keyObjs) => {
  let experiment_dict = {};
  let allS3Files = keyObjs.map((key) => key.Key);
  for (let filename of allS3Files) {
    let key = filename.replace(awsExports.ACCESS_PREFIX, '');
    let pathElements = key.split('/');
    if (pathElements.length !== 3) { continue; }
    // should be in form: group-name/experiment-timestamp/file-name
    let timestamp = pathElements[1] 
    
    if (!(timestamp in experiment_dict)) {
      experiment_dict[timestamp] = new ExperimentFolder(timestamp, filename.match(/(.*)[/\\]/)[1])
    }

    experiment_dict[timestamp].s3Files.push(filename)
  }

  for (const timestamp in experiment_dict) {
    if (!(experiment_dict[timestamp].s3Files.includes(experiment_dict[timestamp].dataKey))) {
      delete experiment_dict[timestamp]
    }
  }

  await assembleTags(Object.values(experiment_dict));

  let experiments = Object.values(experiment_dict).flat(Infinity);;

  await assembleIssues(experiments)

  return experiments;
}

export const assembleTags = async (experiments) => {
  for (let ind in experiments) {
    let exp = experiments[ind];
    if (!exp.s3Files.includes(exp.dataKey)) { continue; }
    let tags = await getS3ObjectTags(exp.dataKey);
    for (let tag in tags['TagSet']) {
      let [ key, value ] = [ tags['TagSet'][tag].Key, tags['TagSet'][tag].Value ];
      if (key.toLowerCase().includes('start')) { exp.startDate = parseInt(value); }
      if (key.toLowerCase().includes('end')) { exp.setEndDate(parseInt(value)); }
      if (key.toLowerCase().includes('experiment_id')) { exp.name = value; }
      if (key.toLowerCase().includes('incubator')) { exp.incubator = value; }
    }
  }
}

export const assembleIssues = async (experiments, issueLogKey="issueLog") => {
  let allIssues = [];
  for (let ind in experiments) {
    let exp = experiments[ind];
    if (!exp.s3Files.includes(exp.issuesKey)) { continue; }
    let issuesJson = JSON.parse(await getS3Object(exp.issuesKey));
    issuesJson[issueLogKey].forEach((issue) => {
      allIssues.push(new Issue(
        issue['id'], issue['title'], issue['resolved'], issue['messages'], exp
      ));
      if (issue['resolved'] === false) { exp.setFlagged(true); }
      else {exp.setFlagged(false)}
    });
  }


  return allIssues;
}

